import VueRouter from 'vue-router'
import routes from './routes'
import guard from './guard'

const router = new VueRouter({
  mode: 'hash',
  routes
})

router.beforeEach(guard)

export default router
